import { render, staticRenderFns } from "./logoslideshow.vue?vue&type=template&id=21481fd4&"
import script from "./logoslideshow.vue?vue&type=script&lang=js&"
export * from "./logoslideshow.vue?vue&type=script&lang=js&"
import style0 from "./logoslideshow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports